import mwcMarketsCore from 'mwc-markets-core';
import Component from './src/treasury';

const { createCustomElement } = mwcMarketsCore;

export default createCustomElement(Component);
